// src/utils/statusColors.js
export const statusColor = {
    Placed: 'info',
    Accepted: 'primary',
    Preparing: 'info',
    Ready_For_Pickup: 'warning',
    Picked_Up: 'dark',
    Delivered: 'success',
    Cancelled: 'danger',
    // Transaction statuses
    Captured: 'success',
    Authorized: 'success',
    Paid: 'success',
    Pending: 'warning',
    Failed: 'danger',
    Declined: 'danger',
    Cancelled: 'danger',
    refunded: 'info',
    processing: 'primary',
  };
  